var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-radio-group',{staticClass:"mt-1",attrs:{"mandatory":""},model:{value:(_vm.ringtone),callback:function ($$v) {_vm.ringtone=$$v},expression:"ringtone"}},_vm._l((_vm.ringtones),function(r){return _c('v-radio',{key:r.name,attrs:{"label":r.name,"value":r}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }